import { format } from '@querodelivery/qd-date-helper';
import { Table } from '@quero-delivery/quero-components-web';
import { centsToMoneyLabel } from '@/Utils/FnUtils';
import type { Ticket } from '@/_features/places/types';

type Props = {
  tickets?: Ticket[];
};

export const PixTable = ({ tickets }: Props) => {
  return (
    <>
      {tickets && tickets.length > 0 ? (
        <>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Valor</Table.HeaderCell>
              <Table.HeaderCell>Data de pagamento</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {tickets.map(ticket => (
              <Table.Row key={ticket._id}>
                <Table.Cell>{centsToMoneyLabel(ticket.valorCents)}</Table.Cell>
                <Table.Cell>
                  {ticket.pagoAt ? format(ticket.pagoAt, 'dd/MM/yyyy') : '---'}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </>
      ) : (
        <span className="body2">Nenhum PIX encontrado</span>
      )}
    </>
  );
};
